import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Index from "./page/index";
import About from "./page/about";
import Service from "./page/service";
import Work from "./page/work";
import Contact from "./page/contact";
import PolicyPrivacy from "./page/policy_privacy";

import Notfound from "./page/notfound";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Index />} />
    <Route path="/about" element={<About />} />
    <Route path="/service" element={<Service />} />
    <Route path="/work" element={<Work />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/policy-privacy" element={<PolicyPrivacy />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
